import { useField } from 'formik';
import React from 'react';
import { Props } from './SelectRegions';
import { SelectRegions } from './SelectRegions';

interface FormProps {
    name: string;
}

export const FormSelectRegions: React.FC<
    FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, ...props }) => {
    const [field, , helpers] = useField(name);
    return (
        <SelectRegions
            {...props}
            value={field.value}
            onChange={helpers.setValue}
        />
    );
};
